import React, { useState } from 'react';
import { Layout } from '../Layout';
import ExpandableSection from '@cloudscape-design/components/expandable-section';
import Input from '@cloudscape-design/components/input';
import FormField from '@cloudscape-design/components/form-field';
import Button from '@cloudscape-design/components/button';
import Form from '@cloudscape-design/components/form';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { getApiHeader } from 'src/utils';
import Alert from '@cloudscape-design/components/alert';
import { GroupDetails } from './GroupDetails';

export const GroupCheckIn: React.FC = () => {
    const headers = getApiHeader();

    const [groupChestNumber, setGroupChestNumber] = useState<string>("");
    const [guardianPhoneNumber, setGuardianPhoneNumber] = useState("");
    const [guardianFirstName, setGuardianFirstName] = useState("");

    const { mutate, data: groupData, error, isSuccess, isPending, reset: resetData } = useMutation({
        mutationFn: async (data: { guardianFirstName?: string, groupChestNumber?: string, guardianPhoneNumber?: string }) => {
            const result = await axios.post('https://lq28erxcqe.execute-api.us-east-1.amazonaws.com/Prod/getGroupDetails',
                data, {
                headers
            });
            return result.data.result;
        },
    });

    const reset = () => {
        setGroupChestNumber("");
        setGuardianPhoneNumber("");
        setGuardianFirstName("");
        resetData();
    }

    const searchParticipant = () => {
        mutate({ groupChestNumber, guardianFirstName, guardianPhoneNumber });
    }

    return (
        <Layout breadcrumbs={[
            {
                href: '/group-checkin',
                text: 'Group Check-in'
            }
        ]}>
            <SpaceBetween direction="vertical" size="m">
                <ExpandableSection
                    defaultExpanded
                    variant="container"
                    headerText="Search Group"
                >
                    {
                        error && (
                            <Alert type='error'>{error.message}</Alert>
                        )
                    }
                    <Form
                        actions={
                            <SpaceBetween direction="horizontal" size="xs">
                                <Button onClick={reset} formAction="none" variant="link">
                                    Clear
                                </Button>
                                <Button variant="primary" loading={isPending} onClick={searchParticipant}>Search</Button>
                            </SpaceBetween>
                        }
                    >
                        <SpaceBetween direction="horizontal" size="l">
                            <FormField label="Group Chest number">
                                <Input value={groupChestNumber} onChange={({ detail }) => setGroupChestNumber(detail.value)} placeholder='Chest number' />
                            </FormField>
                            <FormField label="Guardian Phone number">
                                <Input value={guardianPhoneNumber} onChange={({ detail }) => setGuardianPhoneNumber(detail.value)} placeholder='Phone number' />
                            </FormField>
                            <FormField label="Guardian First name">
                                <Input value={guardianFirstName} onChange={({ detail }) => setGuardianFirstName(detail.value)} placeholder='First name' />
                            </FormField>
                        </SpaceBetween>
                    </Form>
                </ExpandableSection>
                {
                    groupData && (<GroupDetails groups={groupData} />)
                }
            </SpaceBetween>
        </Layout>
    );
}